document.addEventListener('DOMContentLoaded', () => {
  const triggerBtn = document.querySelector('.apa-chat');
  const chatWidget = document.getElementById('gcp-help-agent-widget');
  const closeBtn = document.getElementById('gcp-chat-close');
  const chatForm = document.getElementById('gcp-chat-form');
  const chatInput = document.getElementById('gcp-chat-input');
  const messagesContainer = document.getElementById('gcp-chat-messages');

  // Replace with your actual Cloud Run URL once deployed
  const CLOUD_RUN_API_URL = "https://backend-agent-227309968333.us-east4.run.app/webhook/customer-inquiry"; 
  
  // Create an anonymous session ID for the user
  const sessionId = sessionStorage.getItem('gcp_chat_session') || 'sess_' + Math.random().toString(36).substring(2, 9);
  sessionStorage.setItem('gcp_chat_session', sessionId);

  // Toggle Widget
  function toggleChat(e) {
    if (e) e.preventDefault();
    chatWidget.classList.toggle('is-open');
    if (chatWidget.classList.contains('is-open')) {
      chatInput.focus();
      if (triggerBtn) triggerBtn.classList.add('is-hidden');
    } else {
      if (triggerBtn) triggerBtn.classList.remove('is-hidden');
    }
  }

  if (triggerBtn) {
    triggerBtn.addEventListener('click', toggleChat);
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', toggleChat);
  }

  // Add Message to UI
  function addMessage(text, sender) {
    const msgDiv = document.createElement('div');
    msgDiv.classList.add('gcp-msg', sender === 'user' ? 'gcp-msg-user' : 'gcp-msg-bot');
    msgDiv.textContent = text;
    messagesContainer.appendChild(msgDiv);
    messagesContainer.scrollTop = messagesContainer.scrollHeight;
  }

  // Handle Submit
  if (chatForm) {
    chatForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const message = chatInput.value.trim();
      if (!message) return;

      // 1. Show user message
      addMessage(message, 'user');
      chatInput.value = '';

      // 2. Show typing indicator (simulated)
      const typingId = 'typing-' + Date.now();
      const typingDiv = document.createElement('div');
      typingDiv.id = typingId;
      typingDiv.classList.add('gcp-msg', 'gcp-msg-bot');
      typingDiv.innerHTML = '<span style="opacity: 0.5">Agent is typing...</span>';
      messagesContainer.appendChild(typingDiv);
      messagesContainer.scrollTop = messagesContainer.scrollHeight;

      // 3. Send to Cloud Run Backend
      try {
        const response = await fetch(CLOUD_RUN_API_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            customer_id: sessionId,
            message: message,
            context: {
              url: window.location.href,
              userAgent: navigator.userAgent
            }
          })
        });

        const data = await response.json();
        
        // Remove typing indicator
        document.getElementById(typingId).remove();
        
        // Show AI response
        if (data && data.status === 'success' && data.reply) {
          addMessage(data.reply, 'bot');
        } else if (data && data.status === 'rejected') {
          addMessage("Your request was rejected by our security firewall.", 'bot');
        } else {
          addMessage("Sorry, I'm currently disconnected from the mainframe.", 'bot');
        }
        
      } catch (error) {
        document.getElementById(typingId).remove();
        addMessage("Network error connecting to the AI Help Agent.", 'bot');
        console.error("GCP Chat Error:", error);
      }
    });
  }
});
